import Vue from 'vue'
import Vuex from 'vuex'
import ttboxService from './services/ttboxService'
import netatmoService from './services/netatmoService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    connecte: true,
    interfaces: [],
    unites: [],
    regles: [],
    statusThermostat: {}
  },
  getters: {
    getInterfaces: (state) => () => {
      return state.interfaces
    },
    getUnite: (state) => (idUnite) => {
      return state.unites.find(unites => unites.idUnite === idUnite)
    },
    getOptionsInterfaces: (state) => (es) => {
      let optionsInterfaces = []
      state.interfaces.forEach(ttInterface => {
          ttInterface.optionsInterfaces.forEach(optionInterface => {
              if (optionInterface.es == es) {
                  optionInterface.libelle = ttInterface.libInterface + "." + optionInterface.libOptionInterface
                  optionInterface.idTypeProtocole = ttInterface.idTypeProtocole
                  optionsInterfaces.push(optionInterface)
              }
          })
      });
      return optionsInterfaces.sort((a, b) => a.libelle.localeCompare(b.libelle));
    },
    getLibelleOptionInterface: (state) => (idOptionInterface) => {
      var libOptionInterface = ''
      state.interfaces.forEach(ttInterface => {
        ttInterface.optionsInterfaces.forEach(optionInterface => {
            if (optionInterface.idOptionInterface == idOptionInterface) {
              libOptionInterface = ttInterface.libInterface + "." + optionInterface.libOptionInterface
            }
        })
      });
      return libOptionInterface
    }
  },
  mutations: {
    connecte(state){
      state.connecte = true
    },
    deconnecte(state){
      state.connecte = false
    },
    listeInterfaces(state, { interfaces } ){
      state.interfaces = interfaces
    },
    listeUnites(state, { unites }){
      state.unites = unites
    },
    listeRegles(state, { regles } ){
      state.regles = regles
    },
    statusThermostat(state, { status } ){
      state.statusThermostat = status
    }    
  },
  actions: {
    connecter({ commit }, user) {
      return new Promise(function (resolve, reject) {
        ttboxService.connecter(user.username, user.password)
        .then(() => {
          commit('connecte')
          resolve()
        })
        .catch(() => reject())
      })
    },
    deconnecter({ commit }) {
      ttboxService.deconnecter()
      commit('deconnecte')
    },
    lireUnites({ commit }) {
      return new Promise(function (resolve, reject) {
        ttboxService.lireUnites()
        .then((unites) => {
          commit('listeUnites', { unites })
          resolve()
        })
        .catch(() => reject())
      })
    },
    lireInterfaces({ commit }) {
      ttboxService.lireInterfaces()
      .then((interfaces) => {
        commit('listeInterfaces', { interfaces })
      })
    },
    executerOption ({}, optionInterface) {
      return ttboxService.executerOption(optionInterface)
    },
    lireValeursOptionInterface({}, params) {
      return ttboxService.lireValeursOptionInterface(params.idOption, params.periode, params.annee, params.mois, params.jour)
    },
    lireRegles({ commit }) {
      ttboxService.lireRegles()
      .then((regles) => {
        commit('listeRegles', { regles })
      })
    },
    creerRegle({}, regle) {
      return ttboxService.creerRegle(regle)
    },
    modifierRegle({}, regle) {
      return ttboxService.modifierRegle(regle)
    },
    supprimerRegle({}, regle) {
      return ttboxService.supprimerRegle(regle)
    },
    lireStatusThermostat({ commit }) {
      return new Promise(function (resolve, reject) {
        netatmoService.lireStatusThermostat()
        .then((status) => {
          commit('statusThermostat', { status })
          resolve(status)
        })      
        .catch(() => reject())
      })
    },
    async supprimerConsigneManuelleThermostat({ dispatch, state }) {
      await netatmoService.ecrireConsigneThermostat(state.statusThermostat.home_id, state.statusThermostat.room_id, "home")
      await dispatch('lireStatusThermostat')
    },
    async allumerThermostat({ dispatch, state }) {
      await netatmoService.ecrireModeThermostat(state.statusThermostat.home_id, "schedule")
      await netatmoService.ecrireConsigneThermostat(state.statusThermostat.home_id, state.statusThermostat.room_id, "home")
      await dispatch('lireStatusThermostat')
    },
    async eteindreThermostat({ dispatch, state }) {
      await netatmoService.ecrireModeThermostat(state.statusThermostat.home_id, "schedule")
      await netatmoService.ecrireConsigneThermostat(state.statusThermostat.home_id, state.statusThermostat.room_id, "off")
      await dispatch('lireStatusThermostat')
    },
    async modeAbsenceThermostat({ dispatch, state }) {
      await netatmoService.ecrireModeThermostat(state.statusThermostat.home_id, "away")
      await netatmoService.ecrireConsigneThermostat(state.statusThermostat.home_id, state.statusThermostat.room_id, "home")
      await dispatch('lireStatusThermostat')
    },
    async modeHgThermostat({ dispatch, state }) {
      await netatmoService.ecrireModeThermostat(state.statusThermostat.home_id, "hg")
      await netatmoService.ecrireConsigneThermostat(state.statusThermostat.home_id, state.statusThermostat.room_id, "home")
      await dispatch('lireStatusThermostat')
    },
    async ecrireConsigneThermostat({ dispatch, state }, params) {
      await netatmoService.ecrireConsigneThermostat(state.statusThermostat.home_id, state.statusThermostat.room_id, "manual", params.temp, params.endtime)
      await dispatch('lireStatusThermostat')
    },
    lireDonneesNetAtmo({ state }, params ) {
      return netatmoService.lireDonnees(state.statusThermostat.idDevice, state.statusThermostat.idModule,
          params.scale, params.type, params.timestampDebut, params.timestampFin)
    },
    lireDonneesPieceNetAtmo({ state }, params ) {
      return netatmoService.lireDonneesPiece(state.statusThermostat.home_id, state.statusThermostat.room_id,
          params.scale, params.type, params.timestampDebut, params.timestampFin)
    }
  }
})
